import { EXECUTION, IDEA, IMPLEMENTATION, PREPARATION, STOPPED } from '@/model/innovation-project/states'

export default {
    content: {
        [EXECUTION]: 'Excecution',
        [IDEA]: 'Idea',
        [IMPLEMENTATION]: 'Finished',
        [PREPARATION]: 'Preparation',
        [STOPPED]: 'Stopped'
    },

    tooltip: {
        [EXECUTION]: 'Excecution',
        [IDEA]: 'Idea',
        [IMPLEMENTATION]: 'Finished',
        [PREPARATION]: 'Preparation',
        [STOPPED]: 'Stopped'
    }
}
